const INITIAL_STATE = {
  data: {},
  errors: {},
          
}
const voidInvoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'VOID_INVOICE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'VOID_INVOICE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
          
export default voidInvoice;